import React from 'react'
import { Route, Redirect } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'


const PageLayout  = Loadable({ loader: () => import('layers/lsc-transportControl/containers/PageLayout/PageLayout'), loading })
const HomePage    = Loadable({ loader: () => import('layers/lsc-transportControl/pages/HomePage/HomePage'), loading })
const PsrPage     = Loadable({ loader: () => import('layers/lsc-transportControl/pages/PsrPage/PsrPage'), loading })


export default (links) => (
  <Route>
    <Route component={PageLayout}>
      <Route path={links.root} component={PsrPage} />
      <Route path={links.report} component={HomePage} />
      <Route path={links.violation} component={HomePage} />
      <Route path={links.deviation} component={HomePage} />

      <Redirect path={`${links.root}/*`} to={links.root} />
    </Route>
  </Route>
)
